<!--地图-->
<template>
	<div class="mapBody">
		<div class="search-box-content">
			<div class="search-input">
				<el-input placeholder="" v-model="searchStr" class="form-search-input">
					<span slot="prepend" class="search-text">搜索</span>
					<el-button slot="append" icon="el-icon-search" @click="toSearch"></el-button>
				</el-input>
			</div>
			<div class="search-content">
				<el-scrollbar style="height:400px;">
					<!--返回-->
					<div v-show="isShow!=0" style="border-bottom: 1px solid #DCDFE6;height: 40px;display: flex;align-items: center;" @click="blackClick()">
						<img :src="getResourcesByName('arrow/list_back.png')" style="padding-left: 5px;" />
					</div>
					<div v-if="isShow==0" style="width: 100%;height: 100%;">
						<div class="cable-data" v-for="item in dataList" @click="cableClick(item)">
							<div class="cable-data-content">
								<div class="cable-state"><span style="color: white;">正常</span></div>
								<div class="cable-data-content-left">
									<p>{{item.name}}</p>
									<p>测温点:<span>{{leng(item)}}个</span></p>
								</div>
								<div style="padding-right: 5px;">
									<img :src="getResourcesByName('arrow/listRightIcon.png')" />
								</div>
							</div>
						</div>
					</div>
					<div v-if="isShow == 1" style="width: 100%;height: 100%;">
						<div class="cable-data" v-for="item in tempList" @click="tempClick(item)">
							<div class="cable-data-content">
								<div class="cable-state"><span style="color: white;">{{item.value}}°C</span></div>
								<div class="cable-data-content-left">
									<p>{{item.variableName}}</p>
									<p><span>{{item.state}}</span></p>
								</div>
								<div style="padding-right: 5px;">
									<img :src="getResourcesByName('arrow/listRightIcon.png')" />
								</div>
							</div>
						</div>
					</div>
					<div v-if="isShow == 2" style="width: 100%;height: 100%;">
						<div class="temp-content">
							<div class="cable-state"><span style="color: white;">{{tempData.value}}°C</span></div>
							<div class="temp-content-bottom">
								<p>{{tempData.name}}</p>
								<p>状态:<span>已激活</span></p>
								<p>变量名：{{tempData.variableName}}</p>
								<p>设备地址:<span>{{tempData.address}}</span></p>
								<p>水浸状态:<span class="zhuantai" :style="SJStyle(selectState)"></span></p>
							</div>
						</div>
					</div>
				</el-scrollbar>
			</div>
		</div>
		<div id="dekenMap"></div>
	</div>
</template>

<script type="text/javascript">
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {},
		props: [],
		data() {
			return {
				searchStr: '',
				map: undefined,
				dataList: [],
				dataListAll: [],
				tempList: [],
				tempData: {},
				isShow: 0,
				nowVariableNames: [],
				pois: [],
				selectState: 0,

			}
		},
		created() {},
		mounted() {
			debugPage = this
			this.initData()
			this.initMap()
			this.realTimeValueStore.commit("removeKeys", this.nowVariableNames)
		},
		destroyed() {
			this.realTimeValueStore.commit("removeKeys", this.nowVariableNames)
		},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			getResourcesByName() {
				return this.$store.resourcesStore.getters.getResourcesByName
			},
			realTimeValueStore() {
				return this.$store.realTimeValueStore
			},
			rtValue() {
				return this.$store.realTimeValueStore.getters.getValue(this.nowVariableNames)
			},
			SJStyle() {
				return state => {
					let color = "#9999A6"
					if(state == 0) {
						color = "#67C23A"
					} else if(state == 1) {
						color = "red"
					}
					return {
						'background-color': color
					}
				}
			}
		},
		watch: {
			dataList(nv, ov) {
				//拿到数据后获取实时值
				this.nowVariableNames = []
				this.nowVariableNamesSJ = []
				this.dataList.forEach(item => {
					item.state = '--'
					if(!isempty(item.next)) {
						item.next.forEach(item2 => {
							item.value = '--'
							item.state = '--'
							item.suojinValue = '--'
							this.nowVariableNames.push(item2.variableName)
							this.nowVariableNames.push(item2.deviceName + '.浸水')
						})
					}
				})
			},
			nowVariableNames(nv, ov) {
				if(isempty(nv)) {
					return
				}
				this.realTimeValueStore.commit("removeKeys", ov)
				this.realTimeValueStore.commit("addKeys", nv)
			},
			rtValue(nv, ov) {
				let i = 0
				var deviceList = this.nowVariableNames.map(item => item.substring(0, item.indexOf('.'))).distinct()
				var deviceStateMap = this.realTimeValueStore.getters.getDeviceState(deviceList)
				this.dataList.forEach(item => {
					if(!isempty(item.next)) {
						item.next.forEach((item2, index) => {
							item2.value = nv[i]
							i++
							item2.suojinValue = nv[i]
							if(item2.variableName == this.tempData.variableName) {
								this.selectState = nv[i]
							}
							i++
							let state = deviceStateMap[item2.variableName.substring(0, item2.variableName.indexOf('.'))]
							item2.state = state == 0 ? '已激活' : '已激活'
						})
					}
				})
				this.addPonit(this.dataList)
			},
			searchStr(nv, ov) {
				let list = []
				if(isempty(this.searchStr)) {
					this.dataList = this.dataListAll
				} else {
					this.dataListAll.forEach(item => {
						if(item.name.indexOf(this.searchStr) > -1) {
							list.push(item)
						}
					})
					this.dataList = list
				}
			},
			'tempData.suojinValue': {
				deep: true,
				handler(nv, ov) {}
			},
			selectState(nv, ov) {
			}
		},
		methods: {
			toSearch() {},
			initData() {
				this.$api.cableApi.getCableAndPointTree(this.nowUnit.id, respon => {
					if(!isempty(respon)) {
						this.dataList = respon
						this.dataListAll = respon
					}
				})
			},
			initMap() {
				/*初始化百度地图*/
				this.map = new BMap.Map("dekenMap", {
					mapType: BMAP_NORMAL_MAP,
					enableMapClick: false
				})
				this.map.addControl(new BMap.MapTypeControl({
					mapTypes: [
						BMAP_HYBRID_MAP,
						BMAP_NORMAL_MAP
					]
				}));
				this.map.enableScrollWheelZoom(true);
				//初始化中心点
				this.map.centerAndZoom(new BMap.Point(116.404, 39.915), 11);
			},
			addPonit(list) {
				//添加点和线
				let pois = []
				list.forEach(item => {
					if(!isempty(item.next)) {
						let nextPois = []
						item.next.forEach((item2, i) => {
							let obj = item2
							let lat = item2.latitudeAndLongitude.split(',')[0]
							let lon = item2.latitudeAndLongitude.split(',')[1]
							nextPois.push({
								latLog: new BMap.Point(lat, lon),
								value: item2.value
							})
						})
						pois.push(nextPois)
					}
				})
				let sy = new BMap.Symbol(BMap_Symbol_SHAPE_BACKWARD_OPEN_ARROW, {
					scale: 0.6, //图标缩放大小
					strokeColor: '#fff', //设置矢量图标的线填充颜色
					strokeWeight: '2', //设置线宽
				});
				let icons = new BMap.IconSequence(sy, '10', '30');
				pois.forEach(item => {
					if(!isempty(item)) {
						let list = []
						item.forEach(item2 => {
							list.push(item2.latLog)
						})
						var polyline = new BMap.Polyline(list, {
							enableEditing: false,
							enableClicking: true,
							strokeWeight: '5',
							strokeOpacity: 0.8,
							strokeColor: "#FA6036"
						});
						this.map.addOverlay(polyline);
					}
					item.forEach(item2 => {
						var myIcon = new BMap.Icon("/static/image/科技蓝/projectDingZhi/deken/dian1.png", new BMap.Size(30, 30));
						var marker = new BMap.Marker(item2.latLog, {
							icon: myIcon
						});
						this.map.addOverlay(marker);
						if(isempty(item2.value)) {
							item2.value = 0
						}
						var label = new BMap.Label(item2.value, {
							position: item2.latLog,
							offset: new BMap.Size(-20, -35)
						});
						// 自定义文本标注样式
						label.setStyle({
							color: 'black',
							borderRadius: '5px',
							borderColor: '#ccc',
							padding: '5px',
							fontSize: '14px',
						});
						this.map.addOverlay(label);
					})
				})
				//判断是否有选中，有就用有的
				if(isempty(this.tempData)) {
					this.map.centerAndZoom(pois[0][0].latLog, 12)
				} else {
					let lat = this.tempData.latitudeAndLongitude.split(',')[0]
					let lon = this.tempData.latitudeAndLongitude.split(',')[1]
					this.map.centerAndZoom(new BMap.Point(lat, lon), 12)
				}
			},
			cableClick(item) {
				if(!isempty(item.next)) {
					this.tempList = item.next
					this.isShow = 1
				} else {
					this.$message('当前线缆无测温点');
				}
			},
			tempClick(item) {
				this.tempData = item
				this.selectState = item.suojinValue
				this.isShow = 2
				let lat = item.latitudeAndLongitude.split(',')[0]
				let lon = item.latitudeAndLongitude.split(',')[1]
				this.map.centerAndZoom(new BMap.Point(lat, lon), 12)

			},
			leng(item) {
				if(isempty(item.next)) {
					return 0
				} else {
					return item.next.length
				}
			},
			blackClick() {
				if(this.isShow == 1) {
					this.isShow = 0
				} else {
					this.isShow = 1
				}
			}
		}
	}
</script>

<style>
	.mapBody {}
	
	#dekenMap {
		width: 100%;
		height: 100%;
	}
	
	.mapBody .search-box-content {
		width: 20%;
		position: absolute;
		top: 10%;
		left: 15%;
		z-index: 999;
	}
	
	.mapBody .search-input .form-search-input {
		background: rgba(255, 255, 255, 1);
		border: 1px solid rgba(227, 227, 227, 1);
		box-shadow: 0px 1px 4px 0px rgba(67, 67, 67, 0.35);
		border-radius: 3px;
		margin-bottom: 10px;
	}
	
	.mapBody .search-text {
		display: inline-block;
		width: 30px;
		height: 15px;
		font-size: 14px;
		font-family: MicrosoftYaHei;
		font-weight: 400;
		color: rgba(194, 194, 194, 1);
		line-height: 18px;
	}
	
	.el-input-group__prepend,
	.el-input-group__append {
		border: none;
		background: #fff;
	}
	
	.mapBody .search-input .el-input__inner,
	.form-search-input,
	.el-input__inner:focus {
		border: none;
	}
	
	.search-content {
		width: 100%;
		min-height: 400px;
		max-height: 500px;
		background-color: white;
		border-radius: 5px;
	}
	
	.mapBody .el-scrollbar .el-scrollbar__wrap {
		overflow-x: hidden;
	}
	
	.cable-data {
		width: 100%;
		height: 80px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		border-bottom: 1px solid #DCDFE6;
	}
	
	.cable-data-content {
		display: flex;
		align-items: center;
		height: 100%;
		justify-content: space-around;
	}
	
	.cable-state {
		background-color: #67C23A;
		width: 70px;
		height: 65px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-left: 10px;
	}
	
	.el-divider--horizontal {
		margin: 0;
	}
	
	.cable-data-content-left {
		width: calc(100% - 140px);
		height: 60px;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
	}
	
	.cable-data-content-left span {
		border: .01rem solid #60aeff;
		background-color: #ecf5ff;
		color: #60aeff;
		padding: 5px 10px;
		border-radius: 5px;
		margin-left: 10px;
	}
	
	.temp-content {
		height: 350px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	
	.temp-content-bottom {
		width: 80%;
		height: 50%;
	}
	
	.temp-content .cable-state {
		margin-bottom: 10px;
		width: 110px;
		height: 100px;
		margin-top: 30px;
	}
	
	.temp-content-bottom p {
		line-height: .3rem;
	}
	
	.zhuantai {
		padding: .05rem .12rem;
		border-radius: 50%;
		margin-left: .1rem;
	}
</style>